const $ = jQuery.noConflict();

'use strict';
const VerticalSlider = {
	init: function() {
		const tabItem = $('.vertical-slider__link-box-list');
		const imageContainer = $('.vertical-slider__box');
		if (window.innerWidth > 991 && $('.vertical-slider__box').length > 0) {

			tabItem.on('click', function() {
				// Remove active class from all image containers
				imageContainer.removeClass('active');
				tabItem.removeClass('active');

				// Get the ID from the clicked tab (adjust as needed)
				const tabId = $(this).attr('id').replace('heading', '');

				// Add active class to the corresponding image container
				const targetImageContainer = $(`#image${tabId}`);
				targetImageContainer.addClass('active');
				$(this).addClass('active');
			});
		}
	}
};

export default VerticalSlider;
